/* Halvigo theme — interactions */
(function () {
  'use strict';
  var root = window.Halvigo || {};
  var routes = root.routes || { cart_add_url: '/cart/add', cart_change_url: '/cart/change', cart_url: '/cart' };

  /* ---------- drawers (menu + cart) ---------- */
  var lastFocus = null;
  function openDrawer(id) {
    var d = document.getElementById(id);
    if (!d) return;
    lastFocus = document.activeElement;
    d.hidden = false;
    document.documentElement.style.overflow = 'hidden';
    var f = d.querySelector('[data-autofocus]') || d.querySelector('button, a, input');
    if (f) f.focus();
    document.querySelectorAll('[aria-controls="' + id + '"]').forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
  }
  function closeDrawer(d) {
    if (!d || d.hidden) return;
    d.hidden = true;
    document.documentElement.style.overflow = '';
    document.querySelectorAll('[aria-controls="' + d.id + '"]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
    if (lastFocus) lastFocus.focus();
  }
  document.addEventListener('click', function (e) {
    var open = e.target.closest('[data-open-drawer]');
    if (open) { e.preventDefault(); openDrawer(open.getAttribute('data-open-drawer')); return; }
    var close = e.target.closest('[data-close-drawer]');
    if (close) { e.preventDefault(); closeDrawer(close.closest('.drawer')); }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      document.querySelectorAll('.drawer:not([hidden])').forEach(closeDrawer);
      document.querySelectorAll('[data-mega-toggle][aria-expanded="true"]').forEach(function (b) { toggleMega(b, false); });
    }
    if (e.key === 'Tab') {
      var d = document.querySelector('.drawer:not([hidden]) .drawer__panel');
      if (!d) return;
      var items = d.querySelectorAll('a[href], button:not([disabled]), input:not([type=hidden]), select, textarea');
      if (!items.length) return;
      var first = items[0], last = items[items.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  });

  /* ---------- mega menus ---------- */
  function toggleMega(btn, force) {
    var panel = document.getElementById(btn.getAttribute('aria-controls'));
    if (!panel) return;
    var show = typeof force === 'boolean' ? force : btn.getAttribute('aria-expanded') !== 'true';
    document.querySelectorAll('[data-mega-toggle]').forEach(function (b) {
      if (b !== btn) { b.setAttribute('aria-expanded', 'false'); var p = document.getElementById(b.getAttribute('aria-controls')); if (p) p.hidden = true; }
    });
    btn.setAttribute('aria-expanded', show ? 'true' : 'false');
    panel.hidden = !show;
  }
  document.querySelectorAll('[data-mega-toggle]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      if (btn._hoverAt && Date.now() - btn._hoverAt < 800) { toggleMega(btn, true); return; }
      toggleMega(btn);
    });
    btn.addEventListener('mouseenter', function () {
      if (!window.matchMedia('(hover:hover)').matches) return;
      if (btn.getAttribute('aria-expanded') !== 'true') btn._hoverAt = Date.now();
      toggleMega(btn, true);
    });
  });
  var header = document.querySelector('.site-header');
  function closeAllMega() { document.querySelectorAll('[data-mega-toggle]').forEach(function (b) { toggleMega(b, false); }); }
  if (header) header.addEventListener('mouseleave', function () { if (window.matchMedia('(hover:hover)').matches) closeAllMega(); });
  document.addEventListener('click', function (e) { if (header && !header.contains(e.target)) closeAllMega(); });
  document.querySelectorAll('.nav-desktop > a, .header__right a').forEach(function (a) {
    a.addEventListener('mouseenter', function () { if (window.matchMedia('(hover:hover)').matches) closeAllMega(); });
  });

  /* ---------- cart ---------- */
  function renderCart(sections) {
    if (sections && sections['cart-drawer']) {
      var html = new DOMParser().parseFromString(sections['cart-drawer'], 'text/html');
      var fresh = html.querySelector('#CartDrawer');
      var cur = document.getElementById('CartDrawer');
      if (fresh && cur) {
        var wasOpen = !cur.hidden;
        cur.innerHTML = fresh.innerHTML;
        cur.hidden = !wasOpen;
      }
    }
    if (sections && sections['main-cart']) {
      var page = document.getElementById('MainCart');
      var doc2 = new DOMParser().parseFromString(sections['main-cart'], 'text/html').getElementById('MainCart');
      if (page && doc2) page.innerHTML = doc2.innerHTML;
    }
    fetch(routes.cart_url + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('[data-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count;
          el.hidden = cart.item_count === 0;
        });
        document.querySelectorAll('[data-cart-label]').forEach(function (el) {
          el.setAttribute('aria-label', 'Bag, ' + cart.item_count + ' items');
        });
      });
  }
  function sectionIds() {
    var ids = ['cart-drawer'];
    if (document.getElementById('MainCart')) ids.push('main-cart');
    return ids.join(',');
  }
  function toast(msg) {
    var t = document.getElementById('Toast');
    if (!t) return;
    t.textContent = msg; t.hidden = false;
    clearTimeout(t._h); t._h = setTimeout(function () { t.hidden = true; }, 2600);
  }
  function addItems(items, btn) {
    if (btn) { btn.setAttribute('aria-busy', 'true'); btn.disabled = true; }
    return fetch(routes.cart_add_url + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items, sections: sectionIds() })
    }).then(function (r) { return r.json(); }).then(function (res) {
      if (res.status && res.description) { toast(res.description); return; }
      renderCart(res.sections);
      if (!document.getElementById('MainCart')) openDrawer('CartDrawer');
    }).catch(function () { toast('Something went wrong. Please try again.'); })
      .finally(function () { if (btn) { btn.removeAttribute('aria-busy'); btn.disabled = false; } });
  }
  function changeLine(key, qty) {
    return fetch(routes.cart_change_url + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty, sections: sectionIds() })
    }).then(function (r) { return r.json(); }).then(function (res) {
      if (res.status && res.description) { toast(res.description); }
      renderCart(res.sections);
    });
  }
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form.js-ajax-cart');
    if (!form) return;
    e.preventDefault();
    var fd = new FormData(form);
    var id = fd.get('id');
    if (!id) { var err = form.querySelector('[data-variant-error]'); if (err) err.hidden = false; return; }
    var items = [{ id: Number(id), quantity: Number(fd.get('quantity') || 1) }];
    form.querySelectorAll('[data-upsell]:checked').forEach(function (u) { items.push({ id: Number(u.value), quantity: 1 }); });
    addItems(items, form.querySelector('[type=submit]'));
  });
  document.addEventListener('click', function (e) {
    var quick = e.target.closest('[data-quick-add]');
    if (quick) { e.preventDefault(); addItems([{ id: Number(quick.getAttribute('data-quick-add')), quantity: 1 }], quick); return; }
    var multi = e.target.closest('[data-add-multi]');
    if (multi) { e.preventDefault(); var ids = multi.getAttribute('data-add-multi').split(',').filter(Boolean); addItems(ids.map(function (i) { return { id: Number(i), quantity: 1 }; }), multi); return; }
    var qb = e.target.closest('[data-qty]');
    if (qb) {
      e.preventDefault();
      var line = qb.closest('[data-line-key]');
      var input = line.querySelector('input[name="updates[]"], [data-qty-input]');
      var n = Math.max(0, Number(input.value) + Number(qb.getAttribute('data-qty')));
      changeLine(line.getAttribute('data-line-key'), n); return;
    }
    var rm = e.target.closest('[data-remove-line]');
    if (rm) { e.preventDefault(); changeLine(rm.closest('[data-line-key]').getAttribute('data-line-key'), 0); }
  });
  document.addEventListener('change', function (e) {
    var input = e.target.closest('[data-qty-input]');
    if (input) { changeLine(input.closest('[data-line-key]').getAttribute('data-line-key'), Math.max(0, Number(input.value) || 0)); }
  });

  /* ---------- product variant picker ---------- */
  document.querySelectorAll('form.js-product-form').forEach(function (form) {
    var dataEl = form.querySelector('script[data-variants]');
    if (!dataEl) return;
    var variants = JSON.parse(dataEl.textContent);
    var idInput = form.querySelector('input[name="id"]');
    var priceEl = document.querySelector('[data-price]');
    var submit = form.querySelector('[type=submit]');
    var stickyBtn = document.querySelector('[data-sticky-submit]');
    var stickyMeta = document.querySelector('[data-sticky-meta]');
    function selected() {
      var vals = [];
      form.querySelectorAll('fieldset[data-option]').forEach(function (fs) {
        var c = fs.querySelector('input:checked');
        vals.push(c ? c.value : null);
        var lab = fs.querySelector('[data-option-value]');
        if (lab) lab.textContent = c ? c.value : 'Choose';
      });
      return vals;
    }
    function update() {
      var vals = selected();
      var complete = vals.every(function (v) { return v !== null; });
      var match = complete ? variants.find(function (v) { return v.options.every(function (o, i) { return o === vals[i]; }); }) : null;
      var err = form.querySelector('[data-variant-error]'); if (err) err.hidden = true;
      if (!match) {
        idInput.value = '';
        submit.disabled = false; submit.textContent = complete ? 'Unavailable' : submit.getAttribute('data-label');
        if (complete) submit.disabled = true;
        return;
      }
      idInput.value = match.available ? match.id : '';
      if (priceEl) priceEl.innerHTML = match.price_html;
      submit.disabled = !match.available;
      submit.textContent = match.available ? submit.getAttribute('data-label') : 'Sold out';
      if (stickyMeta) stickyMeta.textContent = match.title + ' · ' + match.price_text;
      var url = new URL(window.location.href); url.searchParams.set('variant', match.id);
      window.history.replaceState({}, '', url.toString());
      if (match.media_index != null) {
        var g = document.querySelectorAll('.gallery > *')[match.media_index];
        if (g && window.matchMedia('(max-width:989px)').matches) g.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
      }
    }
    form.addEventListener('change', function (e) { if (e.target.closest('fieldset[data-option]')) update(); });
    if (stickyBtn) stickyBtn.addEventListener('click', function () {
      if (!idInput.value) { form.scrollIntoView({ behavior: 'smooth', block: 'center' }); var err = form.querySelector('[data-variant-error]'); if (err) err.hidden = false; return; }
      form.requestSubmit ? form.requestSubmit() : form.submit();
    });
    var bar = document.querySelector('.sticky-atc');
    if (bar && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (en) { bar.classList.toggle('is-visible', !en.isIntersecting && en.boundingClientRect.top < 0); });
      }).observe(submit);
    }
  });

  /* ---------- collection sort / filters ---------- */
  document.querySelectorAll('[data-facets-form]').forEach(function (form) {
    form.addEventListener('change', function () {
      var params = new URLSearchParams(new FormData(form));
      window.location.search = params.toString();
    });
  });
  document.querySelectorAll('[data-sort]').forEach(function (sel) {
    sel.addEventListener('change', function () {
      var url = new URL(window.location.href); url.searchParams.set('sort_by', sel.value); url.searchParams.delete('page');
      window.location.href = url.toString();
    });
  });

  /* ---------- quiz ---------- */
  document.querySelectorAll('[data-quiz]').forEach(function (quiz) {
    var steps = quiz.querySelectorAll('[data-quiz-step]');
    var total = quiz.querySelectorAll('[data-quiz-step][data-q]').length;
    var bar = quiz.querySelector('.quiz__progress span');
    var counter = quiz.querySelector('[data-quiz-count]');
    var answers = {};
    var idx = 0;
    function show(i, noFocus) {
      idx = i;
      steps.forEach(function (s, k) { s.hidden = k !== i; });
      var isQ = steps[i].hasAttribute('data-q');
      quiz.querySelector('[data-quiz-head]').hidden = !isQ;
      if (isQ) {
        var n = Array.prototype.indexOf.call(quiz.querySelectorAll('[data-quiz-step][data-q]'), steps[i]) + 1;
        if (bar) bar.style.width = (n / total * 100) + '%';
        if (counter) counter.textContent = 'Question ' + n + ' of ' + total;
        var gift = answers.why === 'gift';
        steps[i].querySelectorAll('[data-you]').forEach(function (el) { el.textContent = gift ? el.getAttribute('data-they') : el.getAttribute('data-you'); });
      }
      var h = steps[i].querySelector('[data-result]:not([hidden]) h2') || steps[i].querySelector('h1, h2'); if (h && !noFocus) { h.setAttribute('tabindex', '-1'); h.focus({ preventScroll: true }); quiz.scrollIntoView({ block: 'start', behavior: 'smooth' }); }
    }
    function result() {
      var iron = 0, ice = 0;
      if (answers.why === 'strength') iron += 3;
      if (answers.why === 'cool') ice += 3;
      if (answers.why === 'both' || answers.why === 'gift') { iron += 2; ice += 2; }
      ice += Number(answers.hot || 0);
      iron += [2, 2, 1, 0][Number(answers.lift || 0)];
      if (answers.bed === 'cotton') ice += 1;
      var door = Math.abs(iron - ice) <= 1 ? 'both' : (iron > ice ? 'iron' : 'ice');
      quiz.querySelectorAll('[data-result]').forEach(function (r) { r.hidden = r.getAttribute('data-result') !== door; });
      show(steps.length - 1);
    }
    quiz.addEventListener('click', function (e) {
      var start = e.target.closest('[data-quiz-start]');
      if (start) { show(1); return; }
      var back = e.target.closest('[data-quiz-back]');
      if (back) { show(Math.max(0, idx - 1)); return; }
      var restart = e.target.closest('[data-quiz-restart]');
      if (restart) { answers = {}; quiz.querySelectorAll('.quiz__opt').forEach(function (o) { o.setAttribute('aria-pressed', 'false'); }); show(0); return; }
      var opt = e.target.closest('.quiz__opt');
      if (opt) {
        var step = opt.closest('[data-quiz-step]');
        step.querySelectorAll('.quiz__opt').forEach(function (o) { o.setAttribute('aria-pressed', o === opt ? 'true' : 'false'); });
        answers[step.getAttribute('data-q')] = opt.getAttribute('data-value');
        setTimeout(function () {
          var next = idx + 1;
          if (next >= steps.length - 1) result(); else show(next);
        }, 200);
      }
    });
    show(0, true);
  });

  /* ---------- localization form ---------- */
  document.querySelectorAll('[data-localization]').forEach(function (sel) {
    sel.addEventListener('change', function () { sel.form.submit(); });
  });
})();
